import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, SelectItem } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ScrumboardService } from '../../scrumboard.service';
import { Subject } from 'rxjs';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { ScrumboardCardDialogComponent } from '../dialogs/card/card.component';
import { MatDialog } from '@angular/material';


@Component({
  selector: 'app-work-items',
  templateUrl: './work-items.component.html',
  styleUrls: ['./work-items.component.scss']
})
export class WorkItemsComponent implements OnInit {

  cols: any[];
  totalRecords: number;
  loading: boolean;
  loadEventData: LazyLoadEvent;
  firstname: String;
  lastname: String;
  value: any;
  rowData = [];
  projectId: any;
  projectMembers = [];
  assineeOptions: SelectItem[];
  activeSprintLink: any;
  workItemsLink: any;
  sprintLink: any;
  backlogLink: any;
  sprintTasks = [];
  board: any;
  private _unsubscribeAll: Subject<any>;
  projectName: any;
  boardId: any;
  empRole: any;
  profileId: any;
  selectedProject: any = { name: '', id: '' };
  projectSprintName: any;
  assigneeId: any;
  showFilter: boolean;
  labelList = [];
  listOfTaskType = [];
  priorityValue = [];
  typeOfTaskValue = [];
  sprintList = [];
  sprintId: any;
  dialogRef: any;

  constructor(
    private router: Router,
    private parseService: ParseService,
    private _location: Location,
    private route: ActivatedRoute,
    private storageConfiguration: StorageConfiguration,
    private _scrumboardService: ScrumboardService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) {

    this.cols = [
      { header: 'S.No', field: 'position' },
      { header: 'Title', field: 'title' },
      { header: 'Priority', field: 'priority' },
      { header: 'Status', field: 'status' },
      { header: 'Assignees', field: 'assignee' }];

  }

  async ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;

    this.route.params.subscribe(async params => {
      this.projectId = params.boardId;
      this.projectName = params.boardUri;
    });
    this.getLabels();
    this.typeOfTasks();

    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        let project = results[0].get('project').get('projectInfo');
        // this.projectName = project.projectName;
        this.boardId = results[0].id;
      }
    });

    let sprintInstance = this.parseService.instance.Object.extend('Sprint');
    let sprint = new this.parseService.instance.Query(sprintInstance);
    sprint.include('project');
    sprint.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    await sprint.find().then(results => {
      if (results.length > 0) {
        let project = results[0].get('project').get('projectInfo');
        this.projectSprintName = project.projectName;
      }
    });

    this.getProMembers(this.projectId);
    this.getWorkItems();
    this.getSprintList();
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  async getSprintList() {
    this.sprintList = [];
    let resultArray = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    await query.find().then(results => {
      results.forEach(async element => {
        if (element.get('status') == 'New' || element.get('status') == 'Active' || element.get('status') == 'Closed') {
          resultArray.push({
            id: element.id,
            name: element.get('name'),
            startDate: element.get('startDate'),
            endDate: element.get('endDate'),
            status: element.get('status'),
            createdAt: element.get('createdAt'),
          });
        }
      });
      this.sprintList = resultArray.sort((a, b) => {
        if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return -1; }
        if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return 1; }
      });
    });
  }

  async getProMembers(projectId) {
    await this._scrumboardService.getProjectMembers(projectId).then(async results => {
      results.forEach(element => {
        this.projectMembers.push({
          id: element.get('user').get('profile').id,
          name: element.get('user').get('profile').get('firstName') + ' ' + element.get('user').get('profile').get('lastName'),
          userImage: element.get('user').get('profile').get('profileImageInfo').url,
        });
      });
      this.assineeOptions = this.bindDropDown(this.projectMembers);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id, userImage: a.userImage });
    });
    return dropDownItem;
  }

  async getWorkItems() {
    this.rowData = [];
    let array = [];
    let i = 0;
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('Project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.include('scrumboardList');
    query.include('sprintId');
    query.find().then(results => {
      results.forEach(async element => {
        let assignee = await this.taskRelation(element.get('assignee'));
        let cardStatus = element.get('scrumboardList');

        let employee = assignee.filter(x => x.profileId == this.profileId);
        let estiHours = this.secondsToHms(element.get('estimatedHours'));

        let sprintId = element.get('sprintId')

        if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
          i = i + 1;
          array.push({
            position: i,
            objectId: element.id,
            listId: element.get('scrumboardList').id,
            sprintId: sprintId != undefined ? sprintId.id : '',
            sprintStatus: sprintId != undefined ? sprintId.get('name') : '',
            title: element.get('title'),
            priority: element.get('taskType'),
            assignee: assignee,
            status: cardStatus != undefined ? cardStatus.get('name') : '',
            typeOfTask: element.get('typeOfTask'),
            cardNumber: element.get('cardNumber'),
            updatedAt: element.get('updatedAt'),
            createdAt: element.get('createdAt'),
            taskRole: element.get('taskRole'),
            estimatedHours: estiHours
          });
        }

        this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
      });
    })
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay;
  }


  /**
   * Open card dialog
   *
   * @param cardId
   */
  async editCardDialog(cardId, listId, sprintId, sprintStatus): Promise<void> {
    await this._scrumboardService.getBoard(sprintId);
    this.dialogRef = this.dialog.open(ScrumboardCardDialogComponent, {
      panelClass: 'scrumboard-card-dialog',
      width: '1200px',
      data: {
        cardId: cardId,
        listId: listId,
        sprintId: sprintId,
        sprintStatus: sprintStatus,
        activeStatus: 'New'
      }
    });
    this.dialogRef.afterClosed().subscribe(response => {
    });
  }

  async searchTask(event): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.rowData = [];
      let array = [];
      let i = 0;
      if (event != undefined && event != '') {
        let titleQueryInstance = this.parseService.instance.Object.extend('Tasks');
        let titleQuery = new this.parseService.instance.Query(titleQueryInstance);
        titleQuery.equalTo('Project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
        titleQuery.include('scrumboardList');
        titleQuery.contains('title', event);
        titleQuery.descending('updatedAt');

        let cardNoQueryInstance = this.parseService.instance.Object.extend('Tasks');
        let cardNoQuery = new this.parseService.instance.Query(cardNoQueryInstance);
        cardNoQuery.equalTo('Project', {
          __type: 'Pointer',
          className: 'Project',
          objectId: this.projectId
        });
        cardNoQuery.include('scrumboardList');
        cardNoQuery.equalTo('cardNumber', Number(event));
        cardNoQuery.descending('updatedAt');
        await Promise.all([titleQuery.find(), cardNoQuery.find()]).then(([title, cardNo]) => {
          function secondsToHms(d) {
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);

            var hDisplay = (h <= 9 ? '0' : '') + h;
            var mDisplay = (m <= 9 ? '0' : '') + m;
            var sDisplay = (s <= 9 ? '0' : '') + s;
            return hDisplay + ':' + mDisplay;
          }
          if (title.length > 0) {
            title.forEach(async element => {
              const getRelationAssignee = async function (tasks) {
                let assignee = [];
                await tasks.query().each(innerElement => {
                  assignee.push({
                    name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
                    profileId: innerElement.id,
                    profilePic: innerElement.get('profileImageInfo').url
                  });
                });
                return assignee;
              }
              let assignee = await getRelationAssignee(element.get('assignee'));
              let cardStatus = element.get('scrumboardList');

              let employee = assignee.filter(x => x.profileId == this.profileId);
              let estiHours = secondsToHms(element.get('estimatedHours'));

              if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
                i = i + 1;
                array.push({
                  position: i,
                  objectId: element.id,
                  sprintId: element.get('scrumboardList').id,
                  title: element.get('title'),
                  priority: element.get('taskType'),
                  assignee: assignee,
                  status: cardStatus != undefined ? cardStatus.get('name') : '',
                  typeOfTask: element.get('typeOfTask'),
                  cardNumber: element.get('cardNumber'),
                  updatedAt: element.get('updatedAt'),
                  createdAt: element.get('createdAt'),
                  taskRole: element.get('taskRole'),
                  estimatedHours: estiHours,
                });
              }

              this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
            });
          }
          else {
            cardNo.forEach(async element => {
              const getRelationAssignee = async function (tasks) {
                let assignee = [];
                await tasks.query().each(innerElement => {
                  assignee.push({
                    name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
                    profileId: innerElement.id,
                    profilePic: innerElement.get('profileImageInfo').url
                  });
                });
                return assignee;
              }
              let assignee = await getRelationAssignee(element.get('assignee'));
              let cardStatus = element.get('scrumboardList');

              let employee = assignee.filter(x => x.profileId == this.profileId);
              let estiHours = secondsToHms(element.get('estimatedHours'));

              if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
                i = i + 1;
                array.push({
                  position: i,
                  objectId: element.id,
                  title: element.get('title'),
                  priority: element.get('taskType'),
                  assignee: assignee,
                  status: cardStatus != undefined ? cardStatus.get('name') : '',
                  typeOfTask: element.get('typeOfTask'),
                  cardNumber: element.get('cardNumber'),
                  updatedAt: element.get('updatedAt'),
                  createdAt: element.get('createdAt'),
                  taskRole: element.get('taskRole'),
                  estimatedHours: estiHours
                });
              }

              this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
            });
          }
        });

      } else {
        this.getWorkItems();
      }
    });
  }

  async taskRelation(tasks) {
    let assignee = [];
    await tasks.query().each(innerElement => {
      assignee.push({
        name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
        profileId: innerElement.id,
        profilePic: innerElement.get('profileImageInfo').url
      });
    });
    return assignee;
  }

  backlocation() {
    this._location.back();
  }

  async assigneeFilter() {
    if (this.assigneeId.length > 0) {
      this.rowData = [];
      let array = [];
      let i = 0;
      let queryInstance = this.parseService.instance.Object.extend('Tasks');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('Project', {
        __type: 'Pointer',
        className: 'Project',
        objectId: this.projectId
      });
      query.include('scrumboardList');
      query.find().then(results => {
        results.forEach(async element => {
          let assignee = await this.taskRelation(element.get('assignee'));

          assignee.forEach(res => {
            this.assigneeId.forEach(innerelement => {
              if (res.profileId == innerelement) {

                let cardStatus = element.get('scrumboardList');

                let employee = assignee.filter(x => x.profileId == this.profileId);
                let estiHours = this.secondsToHms(element.get('estimatedHours'));

                if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
                  i = i + 1;
                  array.push({
                    position: i,
                    objectId: element.id,
                    sprintId: element.get('scrumboardList').id,
                    title: element.get('title'),
                    priority: element.get('taskType'),
                    assignee: assignee,
                    status: cardStatus != undefined ? cardStatus.get('name') : '',
                    typeOfTask: element.get('typeOfTask'),
                    cardNumber: element.get('cardNumber'),
                    updatedAt: element.get('updatedAt'),
                    createdAt: element.get('createdAt'),
                    taskRole: element.get('taskRole'),
                    estimatedHours: estiHours
                  });
                }
                this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
              }
            });
          })
        });
      });
    }
    else {
      this.getWorkItems()
    }
  }

  async getLabels() {
    await this._scrumboardService.getLabels().then(async res => {
      let result = res[0];
      this.labelList = result.get('taskType');
    });
  }

  async typeOfTasks() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(results => {
      let result = results[0];
      this.listOfTaskType = result.get('typeOfTask');
    });
  }

  commonFilter() {
    if (this.priorityValue.length > 0 || this.typeOfTaskValue.length > 0 || this.sprintId.length > 0) {
      this.rowData = [];
      let array = [];
      let i = 0;
      let queryInstance = this.parseService.instance.Object.extend('Tasks');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('Project', {
        __type: 'Pointer',
        className: 'Project',
        objectId: this.projectId
      });
      query.include('scrumboardList');
      query.include('sprintId');
      query.find().then(results => {
        results.forEach(async element => {
          let assignee = await this.taskRelation(element.get('assignee'));
          let eventArray = [];
          let condition;
          if (this.priorityValue.length > 0) {
            eventArray = this.priorityValue;
            condition = element.get('taskType');
          }
          else if (this.typeOfTaskValue.length > 0) {
            eventArray = this.typeOfTaskValue;
            condition = element.get('typeOfTask');
          }
          else if (this.sprintId.length > 0) {
            eventArray = this.sprintId;
            if (element.get('sprintId') != undefined) {
              condition = element.get('sprintId').id;
            }
          }
          eventArray.forEach(innerelement => {
            if (condition == innerelement) {
              let cardStatus = element.get('scrumboardList');

              let employee = assignee.filter(x => x.profileId == this.profileId);
              let estiHours = this.secondsToHms(element.get('estimatedHours'));

              if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
                i = i + 1;
                array.push({
                  position: i,
                  objectId: element.id,
                  sprintId: element.get('scrumboardList').id,
                  title: element.get('title'),
                  priority: element.get('taskType'),
                  assignee: assignee,
                  status: cardStatus != undefined ? cardStatus.get('name') : '',
                  typeOfTask: element.get('typeOfTask'),
                  cardNumber: element.get('cardNumber'),
                  updatedAt: element.get('updatedAt'),
                  createdAt: element.get('createdAt'),
                  taskRole: element.get('taskRole'),
                  estimatedHours: estiHours
                });
              }
              this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
            }
          });
        });
      });
    }
    else {
      this.getWorkItems()
    }
  }

  backlogsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/sprint/' + this.projectId + '/' + this.projectName]);
  }

  WorkLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/work-items/' + this.projectId + '/' + this.projectName]);
  }

  sprintsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/sprint-list/' + this.projectId + '/' + this.projectName]);
  }

  reportsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/reports/' + this.projectId + '/' + this.projectName]);
  }

  async activeSprint() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        let project = results[0].get('project').get('projectInfo');
        this.projectName = project.projectName;
        this.boardId = results[0].id;
        this.router.navigate(['/scrumboard/boards/' + this.boardId + '/' + this.projectName]);
      }
      else {
        this.toastr.warning('There is no active sprint');

      }
    });
  }

}
